import { useEffect, useState } from "react";

const useLocaleDetection = () => {
  const [isChineseUser, setIsChineseUser] = useState(false);

  useEffect(() => {
    const detectLocale = () => {
      const browserLanguage =
        navigator.language || (navigator.languages && navigator.languages[0]);

      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const chineseLanguages = ["zh", "zh-CN"];
      const isChineseLanguage = chineseLanguages.some((lang) =>
        browserLanguage?.toLowerCase().includes(lang.toLowerCase()),
      );

      const chinaTimeZones = ["Asia/Shanghai"];
      const isChinaTimeZone = chinaTimeZones.includes(timeZone);

      const result = isChineseLanguage || isChinaTimeZone;
      setIsChineseUser(result);

      return result;
    };

    detectLocale();
  }, []);

  return { isChineseUser };
};

export default useLocaleDetection;
